module.exports = __webpack_public_path__ + "static/media/dog2.4c0a072b.jpeg";